<template>
<!-- eslint-disable max-len -->
<edit-page
  name="Endgame Settings"
  model-name="outro"
  param="outroId"
  page-prefix="/blade/outros"
  :create="createOutro"
  :fetch="getOutro"
  :fetch-types="getOutroTypes"
  :update="updateOutro"
  :remove="deleteOutro"
  :enum-names="['characters', 'variants', 'narrativeTypes', 'speakers']"
  :stub="outro"
  :validator="validator"
  :utils="utils">
<template slot-scope="{ model: outro, enums: { characters, variants, narrativeTypes, speakers }, utils: { unused }, validator }">
  <text-input label v-model.trim="outro.name" :validator="validator.name" required autofocus>
    Name
  </text-input>

  <text-input label v-model.trim="outro.description" textarea>
    Description
  </text-input>

  <narrative-input
    :narratives="outro.narratives"
    :validator="validator.narratives"
    :characters="characters"
    :variants="variants"
    :narrative-types="narrativeTypes"
    :speakers="speakers"
  >
    Narrative
  </narrative-input>
</template>
</edit-page>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

import { narrative } from '../../../utils/validators';
import { unused } from '../../../utils/utils';

import EditPage from '../../ui/pages/EditPage';
import NarrativeInput from '../../ui/inputs/NarrativeInput';

import ArrayInput from '../../ui/inputs/ArrayInput';
import CheckboxInput from '../../ui/inputs/CheckboxInput';
import NumberInput from '../../ui/inputs/NumberInput';
import SelectInput from '../../ui/inputs/SelectInput';
import TextInput from '../../ui/inputs/TextInput';

export default {
  components: {
    EditPage,
    NarrativeInput,
    ArrayInput,
    NumberInput,
    SelectInput,
    TextInput,
    CheckboxInput
  },
  data() {
    return {
      utils: {
        unused
      },
      outro: {
        _id: '',
        name: '',
        description: '',
        narratives: []
      },
      validator: {
        name: { required },
        narratives: narrative(),
      }
    };
  },
  methods: {
    ...mapActions([
      'getOutro',
      'getOutroTypes',
      'createOutro',
      'updateOutro',
      'deleteOutro'
    ])
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/OutroEdit.vue